module.exports = __webpack_public_path__ + "static/media/edit3.34020076.svg";